import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import userFactory from "../../helpers/userFactory";

import { useNavigate, useLocation, useParams } from "react-router-dom";

import { QRCodeSVG } from "qrcode.react";

import { ReactComponent as WhiteLogoSVG } from "../../assets/logo/M_WHITE_LOGO_SQUARE.svg";
import { ReactComponent as OnlineWorld } from "../../assets/online-world.svg";
import { ReactComponent as MobilePhoneSVG } from "../../assets/mockups/mobile-phone.svg";
import { ReactComponent as SquareSmallIcon } from "../../assets/logo/square-small-icon.svg";
import { ReactComponent as WebdesignSVG } from "../../assets/custom-icons/web-design.svg";
import { ReactComponent as MoneySVG } from "../../assets/custom-icons/money.svg";
import { ReactComponent as CoinSVG } from "../../assets/custom-icons/coin.svg";
import { ReactComponent as SilverMedal } from "../../assets/custom-icons/silver-medal.svg";
import { ReactComponent as GoldenMedal } from "../../assets/custom-icons/gold-medal.svg";
import { ReactComponent as BronzeMedal } from "../../assets/custom-icons/bronze-medal.svg";

import * as Material from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import HelpIcon from "@mui/icons-material/Help";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SendIcon from "@mui/icons-material/Send";
import FilterListIcon from "@mui/icons-material/FilterList";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from "@mui/icons-material/Add";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import HubIcon from "@mui/icons-material/Hub";
import LandscapeIcon from "@mui/icons-material/Landscape";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import Feed from "../../components/Feed";

import { sendMessageTo } from "../../contexts/ChatContext";

import { grey } from "@mui/material/colors";

import { AccountStatus } from "../Products";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import MainButton from "../../components/SmallComponents/MainButton";

import CustomModal from "../../components/CustomModal";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import api from "../../helpers/api.js";

import Config, { token } from "../../config.js";

import LinearProgress from "@mui/material/LinearProgress";

import Screen from "../../components/Screen";
import Pagination from "../../components/Pagination";

import { CreateModal } from "../Groups";

import "./styles.css";

import { useChallenge } from "../../contexts/ChallengeContext";

import { ImportFileModal } from "../CustomerImports";

import ChallengePaymentBanner from "../../components/ChallengePaymentBanner";

export default function Home() {
  const { currentChallenge } = useChallenge();

  const [MODAL_changeUserGroupOpen, setMODAL_changeUserGroupOpen] =
    useState(false);
  const [MODAL_importUsersGroupOpen, setMODAL_importUsersGroupOpen] =
    useState(false);

  const REF_userSelected = useRef();

  function handleToggleChangeUserGroup(userInfo) {
    REF_userSelected.current = { ...userInfo };
    setMODAL_changeUserGroupOpen(true);
  }

  const MEMO_UsersList = useMemo(
    () => (
      <UsersList
        changeUserGroup={handleToggleChangeUserGroup}
        handleOpenImportTool={() => setMODAL_importUsersGroupOpen(true)}
      />
    ),
    [currentChallenge]
  );
  const MEMO_Feed = useMemo(() => <Feed />, [currentChallenge]);

  return (
    <Screen title="Painel administrativo">
      <ChallengePaymentBanner className="mt-4" />
      <div className="content pt-3 pb-7">
        {MEMO_UsersList}
        {MEMO_Feed}
      </div>
      <ChangeGroupModal
        open={MODAL_changeUserGroupOpen}
        setOpen={setMODAL_changeUserGroupOpen}
        users={[REF_userSelected.current]}
      />
      <ImportFileModal
        open={MODAL_importUsersGroupOpen}
        setOpen={setMODAL_importUsersGroupOpen}
      />
    </Screen>
  );
}

const UsersList = ({ changeUserGroup, handleOpenImportTool }) => {
  const [rows, setRows] = useState([]);

  const [loadingUsers, setLoadingUsers] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);

  const params = useLocation();

  const paginationRef = useRef({
    currentPage: 1,
    total: null,
    rowsPerPage: null,
  });

  const {
    currentChallenge,
    handleOpenAddUsersTool,
    handleOpenRemoveMemberTool,
    Modal_removeMemberOpen,
    challenges,
  } = useChallenge();

  const [filters, setFilters] = useState({
    quick: {
      filters: [
        filterFabric("Cadastro incompleto", "incomplete", false),
        filterFabric("Não postam a mais de 30 dias", "inactive_30_days", false),
      ],
    },
    subscription: {
      filters: [filterFabric("Status de pagamento", "subscription", false)],
    },
    order: {
      onlyOne: true,
      filters: [
        filterFabric("Mais ativos", "order_by_more_active", true),
        filterFabric("Menos ativos", "order_by_less_active", false),
      ],
    },
    searchBox: {
      text: "",
    },
  });

  const REF_subscriptionFilter = useRef({
    products: params?.state?.filterUsers?.subscription_products || ["*"],
    status: params?.state?.filterUsers?.subscription_status || "*",
  });

  const REF_challengesFilter = useRef(
    params?.state?.filterUsers?.challenge_id ||
      challenges?.map((c) => c.challenge_id)
  );

  function filterFabric(name, filterKey, value, type = "CHECK") {
    return {
      name,
      filterKey,
      value,
      type,
    };
  }

  useEffect(() => {
    if (loadingUsers) loadUsers();
  }, [loadingUsers]);

  useEffect(() => {
    window.addEventListener("updated_user_group", handleUserGroupUpdated);

    return () => {
      window.removeEventListener("updated_user_group", handleUserGroupUpdated);
    };
  }, [rows]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const userId = urlParams.get("userId");
    if (userId) {
      window.openUserDetails(userId);
      urlParams.delete("userId");
    }
  }, []);

  async function handleAdminToggle(user) {
    const payload = {
      challenge_id: currentChallenge.challenge_id,
      member_id: user.member_id,
    };

    const action = user.isAdmin ? "removeAdmin" : "makeAdmin";

    const messages = {
      removeAdmin: {
        success: "Usuário removido de admministrador com sucesso",
        error:
          "Houve um erro ao remover a função de administrador deste usuário",
      },

      makeAdmin: {
        success: "Usuário promovido a administrador com sucesso",
        error:
          "Houve um erro ao adicionar a função de administrador deste usuário",
      },
    }[action];

    try {
      const { data } = await api.patch("challenge/members/" + action, payload);
      window.setSnackbar(messages[data.success ? "success" : "error"]);
      loadUsers();
    } catch (e) {
      console.log(e);
      window.setSnackbar(messages["error"]);
    }
  }

  const columns = [
    {
      field: "avatar",
      headerName: "",
      sortable: false,
      width: 40,
      renderCell: (params) => {
        return (
          <>
            {params.row.avatar ? (
              <img src={params.row.avatar} className="avatar" />
            ) : (
              <div className="avatar"></div>
            )}
          </>
        );
      },
    },
    {
      field: "username",
      minWidth: 200,
      headerName: <h5>Nome completo</h5>,
      sortable: false,
      renderCell: (params) => {
        return (
          <span
            className="open-user-btn"
            onClick={(e) => {
              e.stopPropagation();
              window.openUserDetails(params.row.id);
            }}
          >
            {params.row.username || params.row.email}
            <OpenInNewIcon className="open-user-icon" />
          </span>
        );
      },
      flex: 1,
    },
    {
      field: "status",
      headerAlign: "center",
      align: "center",
      headerName: <h5>Planos ativos</h5>,
      sortable: false,
      width: 220,
      renderCell: (params) => {
        const { last_payments } = params.row;

        if (!last_payments || last_payments.length === 0)
          return (
            <div className={"subscription-status no-product"}>
              <small className="active-product-name">
                Nenhum produto adquirido
              </small>
            </div>
          );

        //Retorna o produto ativo atualmente, ou o último produto com pagamento registrado
        const productSubscribed =
          last_payments.filter(({ active }) => !!active)[0] ||
          last_payments.sort((a, b) => {
            const dateA = new Date(a.renewed_until);
            const dateB = new Date(b.renewed_until);
            return dateB - dateA;
          })[0];

        const subscribedUntilDays = daysUntilDate(
          productSubscribed.renewed_until
        );

        return (
          <div
            className={
              "subscription-status " +
              (subscribedUntilDays > 7
                ? "active"
                : subscribedUntilDays > 0
                ? "alert"
                : "pending")
            }
          >
            <div className="current-subscription">
              <span className={"subscription-status-marker "}></span>
              <small className="active-product-name">
                {productSubscribed.product_name}
              </small>
            </div>
            <div className="current-subscription">
              <small className="valid-until">
                {subscribedUntilDays > 0 ? "Ativo até:" : "Venceu em:"}{" "}
                {prepareDate(productSubscribed.renewed_until)}
              </small>
              <small className="valid-until-badge">
                {subscribedUntilDays > 0 ? "+" : "há "}
                {Math.abs(subscribedUntilDays)} dias
              </small>
            </div>
          </div>
        );

        function prepareDate(date) {
          const ymd = `${date}`?.split(" ")[0];
          return ymd?.split("-").reverse().join("/") || "-";
        }
        function daysUntilDate(data) {
          const dataAlvo = new Date(data);
          const dataAtual = new Date();
          dataAtual.setHours(0, 0, 0, 0);
          dataAlvo.setHours(0, 0, 0, 0);
          const diferencaEmMilissegundos = dataAlvo - dataAtual;
          const diferencaEmDias = Math.ceil(
            diferencaEmMilissegundos / (1000 * 60 * 60 * 24)
          );
          return diferencaEmDias;
        }
      },
    },
    {
      field: "actions",
      headerName: "",
      headerAlign: "center",
      width: 80,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <div className="table-actions" style={{ gap: "1px" }}>
          <Material.Tooltip title="Enviar mensagem" arrow>
            <Material.IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                sendMessageTo(params.row);
              }}
              children={<SendIcon />}
            />
          </Material.Tooltip>
        </div>
      ),
    },
  ];

  function handleUserGroupUpdated(event) {
    const newInfo = event.detail;
    let rowsCopy = [...rows].map((user) => {
      if (user.id === newInfo.user_id) {
        user.group_name = newInfo.new_group_name;
        user.group_id = newInfo.new_group_id;
      }
      return user;
    });
    setRows([...rowsCopy]);
  }
  const getStatus = (user) => {
    if (!user.phone || !user.email || !user.username) return "INCOMPLETE";
    if (!user.posts) return "INACTIVE";
    return "ACTIVE";
  };
  const getRowClassName = (params) => {
    const isSelected = selectedUsers.includes(params?.id);
    const className =
      !isSelected && selectedUsers.length > 0 ? "unselected-row" : "";
    return className;
  };
  function handleRowSelected(selectedIds) {
    setSelectedUsers([...selectedIds]);
  }
  function handleToggleChangeUserGroup(e, userInfo) {
    e.stopPropagation();
    changeUserGroup(userInfo);
  }

  async function loadUsers() {
    try {
      const search = getFiltersAsQueryString();

      const result = await api.get("/customers" + search);

      const data = result.data;

      paginationRef.current.currentPage = data.currentPage;
      paginationRef.current.rowsPerPage = data.rowsPerPage;
      paginationRef.current.total = data.total;

      setRows([...data.users]);
    } catch (e) {
      window.setSnackbar(
        "Houve um erro ao carregar os usuários, por favor tente novamente mais tarde"
      );
    }
    setLoadingUsers(false);

    function getFiltersAsQueryString() {
      try {
        let str = "?page=" + paginationRef.current.currentPage;

        if (filters.searchBox?.text)
          str += "&search_string=" + filters.searchBox.text;

        const filterProducts = REF_subscriptionFilter.current.products;
        str +=
          "&subscription_products=" +
          (filterProducts[0] === "*" ? "*" : JSON.stringify(filterProducts));
        str += "&subscription_status=" + REF_subscriptionFilter.current.status;

        str +=
          "&challenges_id=" +
          (REF_challengesFilter.current.length === challenges.length
            ? "*"
            : JSON.stringify(REF_challengesFilter.current));

        return str;
      } catch (e) {
        return "";
        console.log(e);
      }
    }
  }

  async function handleFilter(section, key, value = null) {
    const filterIndex = filters[section].filters.findIndex(
      (filter) => filter.filterKey === key
    );
    const filtersCopy = { ...filters };
    const filterInfo = filtersCopy[section].filters[filterIndex];

    if (filterInfo.type === "CHECK") {
      if (filtersCopy[section].onlyOne) {
        filtersCopy[section].filters = [
          ...filtersCopy[section].filters.map((filter) => {
            filter.value = false;
            return filter;
          }),
        ];
      }
      filtersCopy[section].filters[filterIndex].value = !filterInfo.value;
    } else {
      filtersCopy[section].filters[filterIndex].value = value;
    }

    paginationRef.current.currentPage = 1;

    setFilters({ ...filtersCopy });
    setLoadingUsers(true);
  }

  function Filters() {
    const ChipFilter = ({ name, filterKey, value, section }) => {
      return (
        <Material.Chip
          onClick={() => handleFilter(section, filterKey)}
          label={name}
          className={!!value ? "chip-active" : "chip-inactive"}
          clickable={!loadingUsers}
          variant={!value ? "outlined" : "filled"}
        />
      );
    };
    const FilterChipsList = ({ children, title, section }) => {
      const chips = filters[section].filters;
      return (
        <div className="filter-chips">
          {title && <h5>{title}</h5>}
          {chips.map((chip, i) => (
            <ChipFilter key={i} {...chip} section={section} />
          ))}
          {children}
        </div>
      );
    };
    const SubscriptionStatusFilter = ({}) => {
      const [productsChecked, setProductsChecked] = useState(
        REF_subscriptionFilter.current.products
      );
      const [statusActive, setStatusActive] = useState(
        REF_subscriptionFilter.current.status
      );

      const statuses = [
        {
          key: "*",
          labels: {
            multiple: "Todos",
            alone: "Todos",
          },
        },
        {
          key: "at_least_one_active",
          labels: {
            multiple: "Pelo menos um ativo",
            alone: "Ativo",
          },
        },
        {
          key: "none_active",
          labels: {
            multiple: "Inativo",
            alone: "Inativo",
          },
        },
      ];

      useEffect(() => {
        if (loadingProducts) loadProducts();
      }, [loadingProducts]);

      useEffect(() => {
        REF_subscriptionFilter.current.status = statusActive;
      }, [statusActive]);
      useEffect(() => {
        REF_subscriptionFilter.current.products = productsChecked;
      }, [productsChecked]);

      const handleChange = (event) => {
        let value = event.target.value;

        if (value[value.length - 1] == "*") {
          value = [..."*"];
        } else if (value.includes("*") && value.length > 1) {
          var index = value.indexOf("*");
          if (index !== -1) {
            value.splice(index, 1);
          }
        }

        if (!value.length) {
          value = ["*"];
        }

        setProductsChecked([...value]);
        setStatusActive("*");
      };

      async function loadProducts() {
        try {
          const { data } = await api.get("/bank/products");
          const activeProducts = data.filter((p) => p.active);
          setProducts([...activeProducts]);
        } catch (e) {
          console.log(e);
        }
        setLoadingProducts(false);
      }

      const isAllProductsSelected =
        productsChecked.includes("*") ||
        productsChecked.length === products.length;

      return (
        <div className="filter-chips subscription-filter-container">
          <Material.Chip
            label={
              <div className="subscription-filter">
                <Material.FormControl>
                  <Material.Select
                    onClose={() => {
                      setTimeout(() => setLoadingUsers(true), 100);
                    }}
                    multiple
                    disabled={loadingProducts}
                    value={productsChecked}
                    onChange={handleChange}
                    input={
                      <Material.OutlinedInput
                        className="chip-input"
                        label="Tag"
                      />
                    }
                    renderValue={(selected) => (
                      <>
                        <span className="chip-title">Produtos</span>:{" "}
                        {isAllProductsSelected
                          ? "Todos"
                          : products
                              ?.filter((p) => productsChecked?.includes(p?.id))
                              ?.map((p) => p.name)
                              ?.join(", ") || "Todos"}
                      </>
                    )}
                  >
                    <Material.MenuItem value="*">
                      <Material.Checkbox checked={isAllProductsSelected} />
                      <Material.ListItemText primary="Todos" />
                    </Material.MenuItem>

                    <Material.Divider>ou</Material.Divider>

                    {products.map(({ id, name }) => (
                      <Material.MenuItem key={name} value={id}>
                        <Material.Checkbox
                          checked={
                            productsChecked?.includes(id) ||
                            isAllProductsSelected
                          }
                        />
                        <Material.ListItemText primary={name} />
                      </Material.MenuItem>
                    ))}
                  </Material.Select>
                </Material.FormControl>
                <Material.Divider flexItem orientation="vertical" />
                <Material.FormControl>
                  <Material.Select
                    disabled={loadingProducts}
                    value={statusActive}
                    onChange={(v) => {
                      const { value } = v.target;
                      setStatusActive(value);
                      setTimeout(() => setLoadingUsers(true), 100);
                    }}
                    input={
                      <Material.OutlinedInput
                        className="chip-input"
                        label="Tag"
                      />
                    }
                    renderValue={(selected) => (
                      <>
                        <span className="chip-title">Status pgto.</span>:{" "}
                        {
                          statuses.filter((s) => s.key === statusActive)[0]
                            .labels[
                            isAllProductsSelected ? "multiple" : "alone"
                          ]
                        }
                      </>
                    )}
                  >
                    {isAllProductsSelected
                      ? statuses.map(({ key, labels }) => (
                          <Material.MenuItem key={key} value={key}>
                            <Material.ListItemText primary={labels.multiple} />
                          </Material.MenuItem>
                        ))
                      : statuses
                          .filter((status) => !status.hideWhenOnlyOneOption)
                          .map(({ key, labels }) => (
                            <Material.MenuItem key={key} value={key}>
                              <Material.ListItemText primary={labels.alone} />
                            </Material.MenuItem>
                          ))}
                  </Material.Select>
                </Material.FormControl>
              </div>
            }
            variant="outlined"
          />
        </div>
      );
    };
    const ChallengesFilter = ({}) => {
      const [challengesChecked, setChallengesChecked] = useState(
        REF_challengesFilter.current || []
      );

      useEffect(() => {
        REF_challengesFilter.current = challengesChecked;
      }, [challengesChecked]);

      const handleChange = (event) => {
        let value = event.target.value;
        console.log(value);
        if (value.includes("*") || value.length === 0) {
          value = challenges.map((c) => c.challenge_id);
        }
        setChallengesChecked([...value]);
      };

      const selectOnly = (challengeId) => {
        console.log(challengeId);
        setChallengesChecked([challengeId]);
      };

      const isAllChallengesSelected =
        challengesChecked.length === challenges?.length;

      function getInputLabel() {
        let label = "";
        if (isAllChallengesSelected) return "Todas";

        const challengeNames = challenges
          ?.filter((c) => challengesChecked?.includes(c?.challenge_id))
          ?.map((c) => c.name);

        if (challengesChecked.length > 1) {
          return challengeNames[0] + " e +" + challengeNames.length;
        }

        return challengeNames[0];
      }

      return (
        <div className="filter-chips subscription-filter-container">
          <Material.Chip
            label={
              <div className="subscription-filter">
                <Material.FormControl>
                  <Material.Select
                    onClose={() => {
                      setTimeout(() => setLoadingUsers(true), 100);
                    }}
                    multiple
                    disabled={false}
                    value={challengesChecked}
                    onChange={handleChange}
                    input={
                      <Material.OutlinedInput
                        className="chip-input"
                        label="Tag"
                      />
                    }
                    renderValue={(selected) => (
                      <>
                        <span className="chip-title">Comunidade</span>:{" "}
                        {getInputLabel()}
                      </>
                    )}
                  >
                    <Material.MenuItem value="*">
                      <Material.Checkbox checked={isAllChallengesSelected} />
                      <Material.ListItemText primary="Todas" />
                    </Material.MenuItem>

                    <Material.Divider>ou</Material.Divider>

                    {challenges?.map(({ challenge_id, name }) => (
                      <Material.MenuItem key={name} value={challenge_id}>
                        <Material.Checkbox
                          checked={challengesChecked?.includes(challenge_id)}
                        />
                        <Material.ListItemText primary={name} />
                        <Material.Button
                          className="ml-1 select-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            selectOnly(challenge_id);
                          }}
                        >
                          Apenas este
                        </Material.Button>
                      </Material.MenuItem>
                    ))}
                  </Material.Select>
                </Material.FormControl>
              </div>
            }
            variant="outlined"
          />
        </div>
      );
    };
    const SearchInput = () => {
      const [inputValue, setInputValue] = useState("");
      const [debouncedValue, setDebouncedValue] = useState(inputValue);

      useEffect(() => {
        const handler = setTimeout(() => {
          if (debouncedValue !== inputValue) setDebouncedValue(inputValue);
        }, 2000);

        return () => {
          clearTimeout(handler);
        };
      }, [inputValue]);

      useEffect(() => {
        if (filters.searchBox.text !== inputValue)
          setInputValue(filters.searchBox.text);
      }, [loadingUsers]);

      useEffect(() => {
        if (debouncedValue && inputValue.trim() !== filters.searchBox.text) {
          handleSubmit(debouncedValue);
        }
      }, [debouncedValue]);

      const handleInputChange = (event) => {
        setInputValue(event.target.value);
      };

      const handleSubmit = (value) => {
        const copy = { ...filters };
        copy.searchBox.text = value.trim();

        setFilters({ ...copy });
        setLoadingUsers(true);
      };

      return (
        <Material.TextField
          label="Buscar participante"
          id="user-search"
          fullWidth
          onBlur={(e) => handleSubmit(e.target.value.trim())}
          onInput={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSubmit(e.target.value.trim());
            }
          }}
          value={inputValue}
          style={{ maxWidth: 300 }}
          InputProps={{
            placeholder: "Insira um nome, email ou telefone",
            endAdornment: (
              <Material.InputAdornment position="start">
                <SearchIcon />
              </Material.InputAdornment>
            ),
          }}
        />
      );
    };

    return (
      <div className="filters-area pt-2 pb-1">
        <div className="filters-row mb-2">
          <SearchInput />
          <div className="filters-row">
            <MainButton
              onClick={handleOpenAddUsersTool}
              label="Adicionar usuário"
              color="white"
              endIcon={<AddIcon />}
              shadow={false}
            />
            <MainButton
              onClick={handleOpenImportTool}
              label="Importar"
              color="white"
              endIcon={<FileUploadIcon />}
              shadow={false}
            />
          </div>
        </div>

        <div className="user-filters">
          <h4 className="filters-box-title">Filtrar usuários</h4>
          <Material.Divider className="mb-1" />
          <div className="filters-container">
            <SubscriptionStatusFilter />
            <ChallengesFilter />
          </div>
        </div>
      </div>
    );
  }

  const FakeRowInfo = {
    renderCell: () => (
      <Material.Skeleton variant="rectangular" width={400} height={30} />
    ),
  };

  return (
    <div className="users-side">
      <ChallengeInfo total={paginationRef.current.total} />

      <h3>Usuários cadastrados</h3>

      <Filters />

      <DataGrid
        color="secondary"
        disableColumnMenu={true}
        hideFooter={true}
        autoHeight
        className="users-table mt-4"
        rows={loadingUsers ? [{ id: 1 }, { id: 21 }, { id: 33 }] : rows}
        selectionModel={selectedUsers}
        columns={
          loadingUsers
            ? [
                { ...columns[0], ...FakeRowInfo },
                { ...columns[2], ...FakeRowInfo },
                { ...columns[3], ...FakeRowInfo },
              ]
            : columns
        }
        checkboxSelection
        onSelectionModelChange={handleRowSelected}
        getRowClassName={getRowClassName}
      />

      <Pagination
        paginationRef={paginationRef}
        setLoadingUsers={setLoadingUsers}
      />
    </div>
  );
};

const ChallengeInfo = ({ total }) => {
  const {
    currentChallenge,
    handleOpenAddUsersTool,
    handleOpenGenerateLinkTool,
  } = useChallenge();

  const Info = ({ text, onPress, buttonText, buttonIcon }) => {
    return (
      <div className="challenge-info p-2">
        <h5>{text}</h5>
        <MainButton
          onClick={onPress}
          label={buttonText}
          color="white"
          endIcon={buttonIcon}
          shadow={false}
        />
      </div>
    );
  };

  return (
    <div className="challenge-info-bar mb-5">
      <div className="challenge-info main-info p-2 mt-3">
        <HubIcon
          color="white"
          height={80}
          width={80}
          className="main-info-icon"
        />

        <div>
          <h5>Usuários</h5>
          <h2>{total || 0}</h2>
        </div>
        <Material.IconButton
          className="add-user-btn-icon"
          onClick={handleOpenAddUsersTool}
          children={<AddIcon color="white" />}
        />
      </div>
      <AccountStatus compactDisplay={true} style={{ maxWidth: "1317px" }} />
    </div>
  );
};

const ChangeGroupModal = ({
  users,
  open,
  setOpen,
  handleUpdated = () => {},
}) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentChallenge } = useChallenge();

  const [updating, setUpdating] = useState(false);

  const [openCreateModal, setOpenCreateModal] = useState(false);

  useEffect(() => {
    if (loading) handleLoadGroups();
  }, [loading, groups]);

  useEffect(() => setLoading(true), [currentChallenge]);

  async function handleLoadGroups() {
    try {
      const result = await api.get(
        "/challenge/groups?challenge_id=" + currentChallenge?.challenge_id
      );

      setGroups([...result.data]);
    } catch (e) {}

    setLoading(false);
  }
  async function handleChangeGroup(data) {
    setUpdating(true);

    try {
      const result = await api.post("/challenge/groups/addMember", {
        challenge_id: currentChallenge?.challenge_id,
        group_id: data.id,
        member_ids: users.map((user) => user.member_id),
      });

      if (result.data.success) {
        window.setSnackbar(
          'Usuário adicionado ao grupo "' + data.name + '" com sucesso'
        );
        if (users.length === 1) {
          const event = new CustomEvent("updated_user_group", {
            detail: {
              user_id: users[0].id,
              new_group_name: data.name,
              new_group_id: data.id,
            },
          });
          window.dispatchEvent(event);
        }
        handleUpdated();
      } else {
        window.setSnackbar(
          "Houve um erro ao adicionar este usuário à um grupo. Por favor tente novamente mais tarde"
        );
      }
    } catch (e) {
      console.log(e);
      window.setSnackbar(
        "Houve um erro ao adicionar este usuário à um grupo. Por favor tente novamente mais tarde"
      );
    }

    setUpdating(false);
    setOpen(false);
  }

  const GroupRow = ({ key, info }) => {
    const current = info.id === users[0]?.group_id && !!users[0]?.group_id;

    return (
      <>
        <div
          style={{ opacity: updating ? 0.4 : 1 }}
          className={"challenge-row " + (current && "selected-row")}
          onClick={() => (updating || current ? null : handleChangeGroup(info))}
        >
          <h5
            style={{
              flexGrow: 1,
              overflow: "hidden",
              textOverflow: "elipsis",
              whiteSpace: "nowrap",
            }}
          >
            {info.name}
          </h5>
          <small className="badge-info">
            {info.members || "Nenhum"} Membro{info.members > 1 && "s"}{" "}
          </small>
          <MainButton
            disabled={current}
            shadow={false}
            variant="contained"
            color="primary"
            small
            onClick={() => handleChangeGroup(info)}
            label={"Selecionar"}
          />
        </div>
        <Material.Divider />
      </>
    );
  };

  return (
    <>
      <CustomModal
        maxWidth={550}
        bottomButtonCancelText="Cancelar"
        hideSecondaryButton={false}
        loading={false}
        title="Selecione um grupo"
        handleSubmit={() => {}}
        open={open}
        handleClose={() => setOpen(false)}
        width="100%"
        bodyWrapperStyle={{}}
        bodyComponent={
          <div className="container">
            <div className="header-row mb-3 pt-2 pr-1">
              <h4>Selecione o grupo de destino</h4>
              <MainButton
                onClick={() => setOpenCreateModal(true)}
                label="Criar grupo"
                color="white"
                endIcon={<AddIcon color="primary" />}
                shadow={false}
              />
            </div>
            {groups &&
              groups?.map((data, i) => <GroupRow key={i} info={data} />)}
          </div>
        }
        modalClass="select-challenge-modal"
        bottomButtonsOrientation="horizontal"
      />
      <CreateModal
        open={openCreateModal}
        setOpen={setOpenCreateModal}
        onCreated={() => setLoading(true)}
      />
    </>
  );
};

export { ChangeGroupModal };
